/* eslint-disable @typescript-eslint/no-explicit-any */
import { Key } from 'react';
import FuelPriceBox from '@apps/components/FuelPriceBox';
import { startCase } from 'lodash';

import {
  ContentWrapper,
  InformativeHolder,
  MenuItem,
  NewsHolder,
  SectionWrapper,
  StickyHolder,
  SubMenu,
} from './styles';

/**
 * ===========================
 * MAIN
 * ===========================
 */
export const CarPlateScreen: React.FC<any> = (props) => {
  const { jpjNumber, settings } = props;
  const fuels = settings.fuel_category;
  const data = jpjNumber;

  // =============== VIEWS
  return (
    <SectionWrapper>
      <NewsHolder>
        <ContentWrapper className="grid grid-2-col">
          <div className="grid-item">
            {data &&
              Object.keys(data).map((area: any, index: Key) => {
                const length = Object.keys(data).length;
                if ((index as number) === length - 1) return;
                return (
                  <>
                    <h5
                      className="text-base"
                      style={{
                        marginBlockStart: '1rem',
                        marginBlockEnd: '10px',
                      }}
                    >
                      {`${startCase(area)} Malaysia`}
                    </h5>
                    <SubMenu key={area}>
                      {data[area].map((rn: any, index: Key) => {
                        return (
                          <MenuItem key={index}>
                            <p
                              style={{
                                fontWeight: 400,
                              }}
                            >
                              {rn?.setting_car_plate_name}
                            </p>
                            <p
                              style={{
                                fontWeight: 700,
                              }}
                            >
                              {rn?.setting_car_plate_no}
                            </p>
                          </MenuItem>
                        );
                      })}
                    </SubMenu>
                  </>
                );
              })}
          </div>
          <div className="grid-item">
            {data &&
              Object.keys(data).map((area: any, index: Key) => {
                const length = Object.keys(data).length;
                if ((index as number) < length - 1) return;
                return (
                  <>
                    <h5
                      className="text-base"
                      style={{
                        marginBlockStart: '1rem',
                        marginBlockEnd: '10px',
                      }}
                    >
                      {`${startCase(area)} Malaysia`}
                    </h5>
                    <SubMenu key={area}>
                      {data[area].map((rn: any, index: Key) => {
                        return (
                          <MenuItem key={index}>
                            <p
                              style={{
                                fontWeight: 400,
                              }}
                            >
                              {rn?.setting_car_plate_name}
                            </p>
                            <p
                              style={{
                                fontWeight: 700,
                              }}
                            >
                              {rn?.setting_car_plate_no}
                            </p>
                          </MenuItem>
                        );
                      })}
                    </SubMenu>
                  </>
                );
              })}
          </div>
        </ContentWrapper>
        {/* <FooterActionWrapper>
          <ShowMoreButton href="/" />
        </FooterActionWrapper> */}
      </NewsHolder>
      <StickyHolder>
        <ContentWrapper className="list">
          <InformativeHolder className="list-item">
            <FuelPriceBox
              lastUpdatedAt="25-02-2024 (WEDNESDAY)  6:00PM"
              fuels={fuels}
            />
          </InformativeHolder>
        </ContentWrapper>
      </StickyHolder>
    </SectionWrapper>
  );
};

/**
 * ===========================
 * EXPORTS
 * ===========================
 */
export default CarPlateScreen;
